import React, { ReactElement } from 'react';
import { Trans, Translation } from 'react-i18next';

import en from 'i18n/en.json';

// takes a json and transforms it recursively into an object that has the same structure
// but 'leaf' nodes' values are their keypaths
const transform = (obj: any, keyPath?: String): any =>
  Object.keys(obj).reduce(
    (newObj, key) =>
      obj[key] && typeof obj[key] === 'object'
        ? {
            ...newObj,
            [key]: transform(obj[key], keyPath ? `${keyPath}.${key}` : key),
          }
        : { ...newObj, [key]: keyPath ? `${keyPath}.${key}` : key },
    {}
  );

export const Strings: typeof en = transform(en);

export type StringsDictionary = { [key: string]: string };
export type Dictionary = { [key: string]: string | Dictionary };

export type LocalizedString = string | ReactElement;

const Localized = (
  string: string,
  options?: { [key: string]: string | number }
): ReactElement => {
  return (
    <Translation>
      {() => (
        <Trans
          i18nKey={string}
          tOptions={options}
          values={options}
          {...options}
        >
          (Localized string not found)
        </Trans>
      )}
    </Translation>
  );
};

export default Localized;
